window.addEventListener('turbolinks:before-render', function () {
    window.zEACLoaded = undefined;
});